module.exports = __webpack_public_path__ + "img/744b755fe48347dbb4d8d9be9447e6bf-60.f9cd79cc.png";